export default {
  name: 're-tab-container',
  
  props: {
    titleClass: { default: ''},
    tabContainerClass: { default: ''}
  },

  data() {
    return {
      tabs: [],
      tab: '',
    }
  },
  computed: {
    activeTab: {
      get() {
        if (this.tab) {
          return this.tab
        }
        for(let tab of this.tabs) {
          if (tab.active) {
            return this.tab = tab.tabName
          }
        }
        return ''
      },
      set(value) {
        this.tab = value
      }

    }
  },
  created() {
      this.tabs = this.$children
  },
  methods: {
  }

}
